import type { QueryClient } from '@tanstack/react-query';
import pino from 'pino';

import { composites } from '../../../../common/constants/access';
import { overviewConstants } from '../../../constants/appConstants';
import { companyFeaturesQuery } from '../../../queries/companyQuery';
import { getVerifyUserAccessQuery, userQuery } from '../../../queries/userQuery';
import { isCompanyOrSupportAdmin } from '../../../selectors/userSelectors';

type RouteParams = {
	teamId: any;
};

export const manageSettlementsLoader = async ({
	queryClient,
	params,
}: {
	queryClient: QueryClient;
	params: RouteParams;
}) => {
	const logger = pino();
	const verifyUserAccessQuery = getVerifyUserAccessQuery((composites as any).WRITE_COMPANY);
	const userData = await queryClient.ensureQueryData(userQuery);
	const userRole = isCompanyOrSupportAdmin(userData.roles)
		? overviewConstants.COMPANY_ADMIN
		: userData.roles.find(role => role.securityGroupId === params.teamId)?.roleId || '';

	const hasAccess = await queryClient.ensureQueryData({
		queryKey: verifyUserAccessQuery.queryKey,
		queryFn: verifyUserAccessQuery.queryFn,
	});

	let companyFeatures;
	try {
		companyFeatures = await queryClient.ensureQueryData(companyFeaturesQuery);
	} catch (error) {
		logger.error(error);
	}
	return {
		userRole,
		userData,
		hasAccess,
		settlements: [],
		companyFeatures,
		showReceiptUpload: companyFeatures.ENABLE_TRANSACTION_RECEIPT_UPLOAD,
		teamId: params.teamId,
	};
};
